export default __webpack_public_path__ + "static/header-marketing-eac5f2dc72c466d67aee4c94ecdf13e6.png";